import { PaginatedApiResponse } from '@/models/PaginatedApiResponse.model';
import { DisbursementDto } from '@/models/suba/disbursements/DisbursementDTO.model';
import { DisbursementReviewRequest } from '@/models/suba/disbursements/DisbursementReviewRequest.model';
import { DisbursementSearchRequest } from '@/models/suba/disbursements/DisbursementSearchRequest.model';
import { DisbursementUpdateNoteRequest } from '@/models/suba/disbursements/DisbursementUpdateNoteRequest.model';
import { InitiateDisbursementRequest } from '@/models/suba/disbursements/InitiateDisbursementRequest.model';
import ApiService from '@/services/Api.service';

export class DisbursementService {
  static async initiate(params: InitiateDisbursementRequest) {
    return ApiService.postJson('/disbursements/initiate', params);
  }

  static async getById(id: number) {
    return ApiService.getJson<DisbursementDto>(`/disbursements/${id}`);
  }

  static async initiateStopCheck(id: number) {
    return ApiService.postJson(`/disbursements/${id}/initiate-stop-check`);
  }
  static async review(id: number, params: DisbursementReviewRequest) {
    return ApiService.postJson<DisbursementReviewRequest, string>(
      `/disbursements/${id}/review`,
      params
    );
  }

  static async updateNote(id: number, params: DisbursementUpdateNoteRequest) {
    return ApiService.patchJson<DisbursementUpdateNoteRequest, void>(
      `/disbursements/${id}/update-note`,
      params
    );
  }

  static async search(params: DisbursementSearchRequest) {
    return ApiService.getJson<PaginatedApiResponse<DisbursementDto[]>>(
      `/disbursements/`,
      { ...params }
    );
  }
}
